export default __webpack_public_path__ + "static/media/Bottom_home.e0106361.svg";